<template>

  <div  >
     <b-table-simple small borderless caption-top responsive >
        <caption class="font-weight-bold"> {{ GraphTitle }}</caption>
      </b-table-simple>

      <div class="small">
        <line-chart class="chartClass_local" :chart-data="datacollection" ref="chart" :options="options"></line-chart>

      </div>

  </div>
</template>

<script>

import LineChart from './LineChart.js'


 export default {
   name: 'GeneralPlot',
   data() {
     return {
     }
   },
   mounted () {

   },
   methods : {
     resetZoom : function() {
       this.$refs.chart.resetZoom();
     },
   },
   components: {
      LineChart
    },
    props: {
     GraphTitle : {
       type: String,
       required: true,
     },
     options: {
      type: Object,
      required: true,
     }, 
     datacollection:  {
      type: Object,
      required: true,
     }, 
   },
}

</script>

<style>
  .small {
    max-height: 800px;
    margin:  50px auto;
  }


  .chartClass_local {
    height: 300px;
  }


</style>
